module.exports = "/images/user-white.svg?ef81cd8d8cd0c9da50f3e114f3f8714d";